import { Text } from '@slal/ui/typography';

export const options = ['Lump sum', 'Regular income', 'Both'];

export const withdrawalOptions = options.map(value => ({
    label:
        value === options[0] ? (
            'Take a lump sum (including tax-free cash)'
        ) : value === options[1] ? (
            'Set up a monthly income'
        ) : (
            <Text tag="span" markdown>
                Take a lump sum **and** set up a monthly income
            </Text>
        ),
    value,
}));

export const initialValues = {
    withdrawal: {
        option: '',
    },
};
